<template lang="pug">
  .container-fluid
    .row.user-state-box(v-if='isLogin')
      .col-7
        p.hello-message.mb-0 ようこそ
          a(href="/mypage")
            span.clarity_mask {{ lastName }} {{ firstName }}さん
      .col-5
        p.point-announce.text-right.mb-0 保有ポイント : {{ point }}pt
    .row.user-state-box(v-if='!isLogin')
      .col-12
        p.point-announce.text-center.mb-0 カラコン全品 送料無料 × 取扱ブランド数 日本最大級
</template>

<script>
import CustomerStore from '../../../stores/CustomerStore'
export default {
  name: 'UserStateBar',
  computed: {
    /**
     * ポイント(フォーマットしている)
     * return ポイント
     */
    point () {
      return String(CustomerStore.state.user.point).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
    },
    /**
     * ログイン済みかどうか
     * @return ログイン済みかどうか
     */
    isLogin () {
      return CustomerStore.state.user.login
    },
    /**
     * 名前を取得する
     * @return 名前
     */
    firstName () {
      return CustomerStore.state.user.firstName
    },
    /**
     * 名前を取得する
     * @return 名前
     */
    lastName () {
      return CustomerStore.state.user.lastName
    }
  },
  /**
   * mounted
   */
  mounted () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../../assets/scss/bootstrap/bootstrap.scss';
.user-state-box {
  font-family: “HiraginoSans”, sans-serif;
  font-size: 12px;
  /*line-height: 20px;*/
  background-color: #F5D24D;
  padding: 2px 0;
  color: #555;
  height: 24px;
}
.hello-message {
  padding: 0px 11px;
  a {
    color: #555;
  }
}
.point-announce {
  padding: 0px 11px;

}
</style>



// WEBPACK FOOTER //
// src/components/sp/common/UserStateBar.vue